module.exports = __webpack_public_path__ + "static/media/speaking.8f84c69c.jpg";